import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik, FormikHelpers, Field } from "formik";
// import PasswordField from "../../../atoms/PasswordField";
import PasswordField from "../../../atoms/TextInput/PasswordField";
import Error from "../../../atoms/Error";
import PasswordStrengthIndicator from "../../../organisms/passwordStrengthIndicator";
import * as yup from "yup";
import { patchData, postData } from "../../../../services";
import toast from "react-hot-toast";
import { confimationStyles, errorStyles } from "../../../../assets/styles/toast";
import { useCookies } from "react-cookie";

const PassForm = ({ uid, expiry, token, type, usertype}) => {

  const navigate = useNavigate();

  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [cookie] = useCookies();

  // Form
  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const validationSchema = yup.object().shape({
    password: yup
      .string()
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;"'`~<>?,./\\|-])/,
        "Password must contain at least one uppercase letter (A-Z), one lowercase letter (a-z), one digit (0-9), and one special character (~`!@#$%^&*()+=-{}[]|:;”’?/<>,.)"
      )
      .required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), ""], "Passwords must match")
      .required("Confirm Password is required"),
  });


  const handleSubmit = async (values, { setSubmitting , resetForm }) => {
    const dataToSend = {
      password: values.password,
      user_id: uid,
      expiry: expiry,
      token: token,
      confirm_password : values.password,
      type : usertype,
    };

    try {
    const endpoint = usertype === "User" ? "User/createPassword"  : "Auth/createPassword"
      const res  = await patchData({
        endpoint: endpoint,
        data: {},
        params: dataToSend,
      });

      resetForm()
      if (res.status) {
        navigate("/auth/login");
        toast.success("Password Reset Successfully", {
          duration: 1000,
          style: confimationStyles,
        });
      }
    } catch (error) {
      toast.error("An error occured", {
        duration: 1000,
        style: errorStyles,
      });
    }
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        handleSubmit,
        touched,
        errors,
        values,
        isValid,
        dirty,
        handleBlur,
        isSubmitting,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <div className="form-group mt-4">
            <>
              <PasswordField
                label="Password"
                id="password"
                name="password"
                value={values.password}
                onChange={(e) => setFieldValue("password", e.target.value)}
                onBlur={handleBlur}
                placeholder="Enter your Password"
                className={`${
                  (touched.password || isSubmitting) && errors.password
                    ? "error-input"
                    : ""
                }`}
              />
              {(touched.password || isSubmitting) && errors.password && (
                <Error error={errors.password} />
              )}
            </>
          </div>

          {/* <PasswordStrengthIndicator
            password={values.password}
            isPasswordValid={isPasswordValid}
            touched={touched.password}
          /> */}

          <div className="form-group mt-4">
            <>
              <PasswordField
                label="Confirm Password"
                id="confirmPassword"
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={(e) =>
                  setFieldValue("confirmPassword", e.target.value)
                }
                onBlur={handleBlur}
                placeholder="Enter your Password"
                className={`${
                  (touched.confirmPassword || isSubmitting) &&
                  errors.confirmPassword
                    ? "error-input"
                    : ""
                }`}
              />
              {(touched.confirmPassword || isSubmitting) &&
                errors.confirmPassword && (
                  <Error error={errors.confirmPassword} />
                )}
            </>
          </div>

          <button
            className="auth_btn btn-primary w-100 mt-4"
            disabled={!isValid || !dirty || isSubmitting}
            type="submit"
          >
            {type === "reset" ? "Reset" : "Create"} Password
            {isSubmitting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default PassForm;
